import Swiper, { Navigation, Pagination } from 'swiper';

function ServicesA1() {
    Swiper.use([Navigation, Pagination]);

    $('[data-module="servicesA1"]').each(function () {
        let previousWidth = window.innerWidth;

        let swiper = new Swiper($(this).find('[data-slider]')[0], {
            slidesPerView: 'auto',
            loop: true,
            loopAdditionalSlides: 3,
            noSwipingSelector: 'a',
            navigation: {
                prevEl: '.js-slider-prev',
                nextEl: '.js-slider-next',
            },
            pagination: {
                el: '.swiper-pagination',
                type: 'progressbar',
            },
            on: {
                beforeResize: (swiper) => {
                    if (window.innerWidth !== previousWidth) {
                        swiper.slides.forEach((slide) =>
                            slide.classList.remove('is-active'),
                        );
                    }
                },
                slideChange: (swiper) => {
                    swiper.slides.forEach((slide) =>
                        slide.classList.remove('is-active'),
                    );
                    swiper.slides[swiper.activeIndex].classList.add(
                        'is-active',
                    );
                },
            },
        });

        window.addEventListener('resize', function () {
            if (window.innerWidth !== previousWidth) {
                swiper.update();

                previousWidth = window.innerWidth;
            }
        });
    });
}

export default ServicesA1;
